export const capitalFirstLetter = (text) => text.charAt(0).toUpperCase() + text.slice(1)